import React, { PureComponent } from 'react';
import { Card, Row, Col, Container, Badge, Button } from 'react-bootstrap';
import { FaFileUpload, FaDownload } from 'react-icons/fa';
import Spinner from '../subcomponent/spinner';
import extractInfoPrecios from '../../middleware/extractInfoPrecios';

const PASOS = [
    { num: 1, icon: '⬇', text: 'Descargá la plantilla CSV' },
    { num: 2, icon: '✏', text: 'Completá la plantilla con los datos de los productos' },
    { num: 3, icon: '⬆', text: 'Cargar la plantilla y generar el archivo plano UN00316B.TXT' },
    { num: 4, icon: '📁', text: 'Copiar el archivo “UN00316B.TXT” generado a la carpeta TRM del directorio del CGUNO' },
    { num: 5, icon: '✔', text: 'Abrir el Sistema CGUNO y Continuar con el proceso desde CGUNO Ruta del CGUNO: /Comercial/Ventas/C/Listas de precios/Generación Vía Archivo' },
];

const NOTAS = [
    ['Código del ítem', '6 dígitos con ceros a la izquierda'],
    ['Precio unitario', 'Sin decimales'],
    ['Unidad de medida', 'Ejemplo: UND'],
    ['Código de lista', '3 dígitos'],
    ['Fecha activación', 'Fecha de inicio del precio'],
    ['Lista / fecha por pantalla', 'Si se especifican en pantalla, deben venir en blanco en el plano'],
];

export default class CargaPrecios extends PureComponent {
    constructor(props) {
        super(props);
        this.csvInputRef = React.createRef();
        this.state = {
            loadingCsv: false,
            loadingText: false,
            dragOverTxt: false,
            toastMessage: null,
        };
    }

    showToast = (message, type = 'success') => {
        this.setState({ toastMessage: { message, type } });
        setTimeout(() => this.setState({ toastMessage: null }), 3500);
    };

    // ── File processors ───────────────────────────────────────────
    uploadTxtFile = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        this.setState({ loadingCsv: true });

        const tmp = [extractInfoPrecios.processCabeceraPrecios()];
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onloadend = () => {
            reader.result.split('\n').forEach((line) => {
                if (line.length >= 144) tmp.push(extractInfoPrecios.processLinePrecios(line));
            });
            this.terminadoCsv(tmp);
        };
    };

    uploadCsvFile = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        this.setState({ loadingText: true });

        const reader = new FileReader();
        reader.readAsText(file);
        reader.onloadend = () => {
            const rows = reader.result.split('\n');
            let tmp = '';
            rows.forEach((element, i) => {
                if (i === 0) return;
                const clean = element.replace(/"/g, '');
                let data = [];
                if (clean.includes(';')) data = clean.split(';');
                else if (clean.includes('\t')) data = clean.split('\t');
                else if (clean.includes(',')) data = clean.split(',');
                if (data.length >= 1) tmp += extractInfoPrecios.processFormatCadenaPrecios(data);
            });
            this.terminadoText(tmp);
            if (this.csvInputRef.current) {
                this.csvInputRef.current.value = '';
            }
        };
    };

    // ── Download helpers ──────────────────────────────────────────
    _download = (content, filename, type) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([content], { type }));
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    _timestamp = () => {
        const d = new Date();
        return [
            d.getFullYear(),
            String(d.getMonth() + 1).padStart(2, '0'),
            String(d.getDate()).padStart(2, '0'),
            String(d.getHours()).padStart(2, '0'),
            String(d.getMinutes()).padStart(2, '0'),
        ].join('');
    };

    terminadoCsv = (tmp) => {
        const csv = tmp.map((r) => r.join(';')).join('\n');
        this._download(csv, `PRECIOS_${this._timestamp()}.csv`, 'text/csv;charset=utf-8');
        this.setState({ loadingCsv: false });
        this.showToast('Archivo CSV generado correctamente.');
    };

    terminadoText = (tmp) => {
        this._download(tmp, 'UN00316B.txt', 'text/plain;charset=utf-8');
        this.setState({ loadingText: false });
        this.showToast('Archivo TXT generado correctamente.');
    };

    descargarPlantillaCsv = () => {
        const csv = extractInfoPrecios.processCabeceraPrecios().join(';') + '\n';
        const d = new Date();
        const date = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
        this._download(csv, `PLANTILLA_PRECIOS_${date}.csv`, 'text/csv;charset=utf-8');
        this.showToast('Plantilla descargada.');
    };

    render() {
        const { loadingText, toastMessage } = this.state;

        const toastStyle = {
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            background: '#1e293b',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '10px',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            zIndex: 9999,
            boxShadow: '0 8px 24px rgba(0,0,0,.15)',
        };

        return (
            <Container fluid className="py-4">
                {/* Header */}
                <div className="text-center mb-4">
                    <h4 className="font-weight-bold text-dark mb-1">Carga de Precios</h4>
                    <p className="text-muted" style={{ fontSize: '14px' }}>
                        Convertí archivos de precios entre formatos CSV y plano TXT para CGUNO
                    </p>
                </div>

                {/* Cards */}
                <Row className="justify-content-center mb-4">
                    {/* Botones a la izquierda */}
                    <Col lg={3} md={5} className="mb-3 mb-lg-0">
                        <Card className="shadow-sm border-0 h-100" style={{ borderRadius: '12px' }}>
                            <Card.Header className="bg-primary text-white py-3" style={{ borderRadius: '12px 12px 0 0' }}>
                                <h5 className="mb-0 d-flex align-items-center">
                                    <FaDownload className="mr-2" /> Acciones
                                </h5>
                            </Card.Header>
                            <Card.Body className="py-4">
                                <div className="text-center mb-4">
                                    <FaDownload size={44} className="text-success mb-3" />
                                    <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                        Descargá la plantilla base para completar la información de precios
                                    </p>
                                    <Button variant="success" onClick={this.descargarPlantillaCsv} block>
                                        <FaDownload className="mr-2" /> Descargar Plantilla
                                    </Button>
                                </div>
                                <hr />
                                <div className="text-center">
                                    <FaFileUpload size={44} className="text-primary mb-3" />
                                    <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                        Cargá la plantilla completada para generar el archivo TXT plano
                                    </p>
                                    <label className="btn btn-primary btn-block">
                                        <input ref={this.csvInputRef} type="file" accept=".csv" onChange={this.uploadCsvFile} style={{ display: 'none' }} />
                                        <FaFileUpload className="mr-2" /> Cargar CSV
                                    </label>
                                    <Spinner loading={loadingText} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Pasos a la derecha */}
                    <Col lg={3} md={5}>
                        <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '12px' }}>
                            <Card.Header className="bg-primary text-white py-3" style={{ borderRadius: '12px 12px 0 0' }}>
                                <h5 className="mb-0">Flujo de trabajo</h5>
                            </Card.Header>
                            <Card.Body className="py-4" style={{ textAlign: 'left' }}>
                                {PASOS.map(({ num, text }) => (
                                    <div key={num} className="d-flex align-items-start mb-4">
                                        <Badge
                                            variant="primary"
                                            className="mr-3 flex-shrink-0"
                                            style={{ minWidth: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px' }}
                                        >
                                            {num}
                                        </Badge>
                                        <p className="mb-0" style={{ lineHeight: '1.7', paddingTop: '3px' }}>{text}</p>
                                    </div>
                                ))}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Notas */}
                <Card className="shadow-sm border-0" style={{ borderRadius: '12px' }}>
                    <Card.Body className="py-4">
                        <p className="text-uppercase font-weight-bold text-muted mb-3" style={{ fontSize: '12px', letterSpacing: '.05em' }}>
                            Notas de formato
                        </p>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                            <tbody>
                                {NOTAS.map(([campo, desc]) => (
                                    <tr key={campo} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td className="font-weight-bold text-secondary" style={{ padding: '8px 10px', whiteSpace: 'nowrap', width: '220px' }}>
                                            {campo}
                                        </td>
                                        <td className="text-muted" style={{ padding: '8px 10px' }}>{desc}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>

                {/* Toast */}
                {toastMessage && (
                    <div style={toastStyle}>
                        <span>✔</span> {toastMessage.message}
                    </div>
                )}
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/archivos/cargaPrecios.jsx